import { createContext, ReactElement, ReactNode, useContext } from 'react';
import { Optional } from 'interfaces/generic';

export enum EProvidersLayout {
  dropdown,
  tags,
  slider
}
export enum EProvidersLogosType {
  default = '0',
  colored = '1'
}

export interface ICasinoProvidersConfigs {
  isFirstCasinoElement: boolean;
  categoryIds: string;
  providerIds: string;
  bindWithCategories: boolean;
  providersLayout: EProvidersLayout;
  providersSliderMode: boolean;
  providersLogosType: EProvidersLogosType;
  isContextLoading: boolean;
}

export interface ICasinoProvidersConfigsProps {
  children: ReactNode;
  value: {
    configs: Optional<
      ICasinoProvidersConfigs,
      'isFirstCasinoElement' | 'providerIds' | 'categoryIds'
    >;
  };
}

const defaultConfigs: Optional<
  ICasinoProvidersConfigs,
  'isFirstCasinoElement' | 'providerIds' | 'categoryIds'
> = {
  isFirstCasinoElement: false,
  categoryIds: '',
  providerIds: '',
  bindWithCategories: false,
  providersSliderMode: false,
  providersLayout: EProvidersLayout.dropdown,
  providersLogosType: EProvidersLogosType.default,
  isContextLoading: true
};

const CasinoProvidersConfigsContext = createContext<
  ICasinoProvidersConfigsProps['value']
>({
  configs: defaultConfigs
});

export const CasinoProvidersConfigsProvider = (
  props: ICasinoProvidersConfigsProps
): ReactElement => {
  const result = {
    ...props.value,
    configs: { ...props.value.configs, isContextLoading: false }
  };

  return (
    <CasinoProvidersConfigsContext.Provider value={result}>
      {props.children}
    </CasinoProvidersConfigsContext.Provider>
  );
};

export const useCasinoProvidersConfigsValues =
  (): ICasinoProvidersConfigsProps['value'] => {
    return useContext(CasinoProvidersConfigsContext);
  };
